var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90606 0.00540819C7.66658 0.0331411 7.43786 0.167328 7.30256 0.407968L0.103838 13.2106C-0.196072 13.744 0.189373 14.4029 0.801286 14.4029H15.1987C15.2933 14.4029 15.3825 14.3871 15.4646 14.3585C15.9134 14.2021 16.1497 13.6615 15.8961 13.2106L8.69742 0.407971C8.52687 0.104654 8.20792 -0.0295341 7.90606 0.00540819ZM7.28075 11.6824C7.28075 12.0801 7.60317 12.4025 8.00088 12.4025C8.3986 12.4025 8.72101 12.0801 8.72101 11.6824C8.72101 11.2847 8.3986 10.9623 8.00088 10.9623C7.60317 10.9623 7.28075 11.2847 7.28075 11.6824ZM8.72101 9.52202C8.72101 9.91974 8.3986 10.2422 8.00088 10.2422C7.60317 10.2422 7.28075 9.91974 7.28075 9.52202V5.92138C7.28075 5.52366 7.60317 5.20125 8.00088 5.20125C8.3986 5.20125 8.72101 5.52366 8.72101 5.92138V9.52202Z",
    fill: "#FFAE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.09423da4328cfb79dfea33c7f1b66b3f.svg";
export { ForwardRef as ReactComponent };